
const TWO_PI = Math.PI * 2;
const DEFAULT_RADIUS = 6;

class Particle {
    constructor() {
        this.alive = false;
        this.radius = DEFAULT_RADIUS;
        this.wander = 0.15;
        this.drag = 0.92;
        this.color = '#ffff';
        this.x = 0;
        this.y = 0;
        this.vx = 0;
        this.vy = 0;
    }

    init(x, y, radius) {
        this.alive = true;
        this.radius = radius || DEFAULT_RADIUS;
        this.theta = Math.random() * TWO_PI;

        this.x = x || 0.0;
        this.y = y || 0.0;
        this.vx = 0.0;
        this.vy = 0.0;
    }

    move() {
        this.x += this.vx;
        this.y += this.vy;
        this.vx *= this.drag;
        this.vy *= this.drag;
        this.theta += (Math.random() - 0.5) * this.wander;
        this.vx += Math.sin(this.theta) * 0.1;
        this.vy += Math.cos(this.theta) * 0.1;
        this.radius *= 0.96;
        this.alive = this.radius > 0.5;
    };

    draw(ctx) {

        ctx.strokeStyle = this.color;
        ctx.lineWidth = this.radius * 2;
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo(this.x, this.y);
        ctx.lineTo(this.x, this.y);
        ctx.stroke();
    }
};

export { Particle };